import {
    BackEndEnvironments,
    BackEndEnvironmentUrls,
    BackEndEnvironmentWebSockets,
    PortalEnvironments,
    PortalEnvironmentUrls
} from "../Assets/variables";

function portalEnvironmentUsed() {
    const baseUrl = window.location.origin;
    for (const [key, urls] of Object.entries(PortalEnvironmentUrls)) {
        if (urls.includes(baseUrl)) return key
    }
    return undefined
}

export function backEndEnvironmentToUse() {
    const environment = portalEnvironmentUsed();
    if (environment === PortalEnvironments.LOCALHOST || environment === PortalEnvironments.DEV) {
        return BackEndEnvironments.QA
    } else if (environment === PortalEnvironments.QA) {
        return BackEndEnvironments.PREPROD
    } else {
        return BackEndEnvironments.PROD
    }
}

export function backEndEnvironmentUrlToUse() {
    const environment = portalEnvironmentUsed();
    if (environment === PortalEnvironments.LOCALHOST || environment === PortalEnvironments.DEV) {
        return BackEndEnvironmentUrls.QA
    } else if (environment === PortalEnvironments.QA) {
        return BackEndEnvironmentUrls.PREPROD
    } else {
        return BackEndEnvironmentUrls.PROD
    }
}

export function backEndEnvironmentWebSocketToUse() {
    const environment = portalEnvironmentUsed();
    if (environment === PortalEnvironments.LOCALHOST || environment === PortalEnvironments.DEV) {
        return BackEndEnvironmentWebSockets.QA
    } else if (environment === PortalEnvironments.QA) {
        return BackEndEnvironmentWebSockets.PREPROD
    } else {
        return BackEndEnvironmentWebSockets.PROD
    }
}

/* Use the same backend environment as the other API explorers. */
export function v3WebSocketUrlToUse() {
    return `${backEndEnvironmentWebSocketToUse()}/web/v3/websocket`;
}
